import { useQuery } from '@tanstack/react-query';
import { queryKeys, offeringsService } from '@v2/services';

export const useBitwerxOfferingDetails = (offeringId: string | null) => {
  const query = useQuery({
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryKey: queryKeys.offerings.bitwerx.detail(offeringId!),
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    queryFn: () => offeringsService.getBitwerxOfferingDetails(offeringId!),
    enabled: !!offeringId,
  });

  return {
    offering: query.data ?? null,
    loading: query.isLoading,
    error: query.error instanceof Error ? query.error.message : null,
    refetch: query.refetch,
  };
};

export default useBitwerxOfferingDetails;
